import React from 'react';

import { ViewOnlyNote } from 'shared/ui/Note/ViewOnlyNote';
import { EditNote } from 'shared/ui/Note/EditNote';

type NoteType = {
  isEditAllowed: boolean;
  note: string;
  isEditNote: boolean;
  submitting: boolean;
  toggleNoteEdit: () => void;
  onSubmit: (note: any) => Promise<any>;
};

export const Note: React.FC<NoteType> = ({ isEditAllowed, note, isEditNote, submitting, toggleNoteEdit, onSubmit }) =>
  isEditAllowed ? (
    <EditNote
      initialData={note}
      isEditNote={isEditNote}
      submitting={submitting}
      toggleNoteEdit={toggleNoteEdit}
      onSubmit={onSubmit}
    />
  ) : (
    <ViewOnlyNote note={note} />
  );
